import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=fbe0cff8&scoped=true&"
import script from "./TicketForm.vue?vue&type=script&lang=js&"
export * from "./TicketForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketForm.vue?vue&type=style&index=0&id=fbe0cff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe0cff8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VTextarea})
